import React from "react";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import "./PolicyPages.css";

const sections = [
  {
    num: "01",
    title: "Use of Website",
    text: "Users agree not to misuse the website, attempt fraud, or engage in illegal activities while using our services.",
  },
  {
    num: "02",
    title: "Product Information",
    text: "We aim to provide accurate product descriptions. However, slight variations in color, packaging, or appearance may occur.",
  },
  {
    num: "03",
    title: "Pricing",
    text: "Prices are subject to change without prior notice. Final prices will be displayed at checkout.",
  },
  {
    num: "04",
    title: "Order Acceptance",
    text: "Kalpana Mart reserves the right to cancel or refuse any order due to stock issues, pricing errors, or suspicious activity.",
  },
  {
    num: "05",
    title: "Intellectual Property",
    text: "All content including logos, images, designs, and text belongs to Kalpana Mart and cannot be reused without permission.",
  },
  {
    num: "06",
    title: "Limitation of Liability",
    text: "We are not responsible for delays caused by courier partners, natural events, or technical issues beyond our control.",
  },
  {
    num: "07",
    title: "Policy Updates",
    text: "Kalpana Mart reserves the right to update these terms anytime without prior notice.",
    highlight: true,
  },
];

const TermsConditions = () => {
  return (
    <>
      <HeaderOne />

      <section className="policy-hero">
        <div className="policy-hero-inner">
          <p className="policy-hero-eyebrow">Kalpana Mart</p>
          <h1>Terms &amp; Conditions</h1>
          <p className="policy-hero-sub">
            Please read these terms carefully before using our website or placing an order.
          </p>
        </div>
      </section>

      <div className="policy-body">
        <div className="policy-content">
          <div className="policy-meta">
            <span className="policy-badge">
              <span className="policy-badge-dot" />
              Effective immediately
            </span>
          </div>

          <p className="policy-intro">
            By accessing and using Kalpana Mart, you agree to comply with the following
            terms and conditions. Please review them thoroughly before making a purchase.
          </p>

          {sections.map((s) => (
            <div className="policy-section" key={s.num}>
              <div className="policy-section-header">
                <span className="policy-section-num">{s.num}</span>
                <h2>{s.title}</h2>
              </div>
              {s.text && !s.highlight && <p>{s.text}</p>}
              {s.text && s.highlight && (
                <div className="policy-highlight">
                  <p>{s.text}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default TermsConditions;